/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import CustomDatePicker from '../../../../components/DatePicker';
import { convertDatesToEpochUTC } from '../../../../CommonMethods/ConvertFilterDatetoEpochUtcFormat';
import dayjs from 'dayjs';
import moment from 'moment';
import ManageActivityHistoryListExport from '../Export';
import FilterActivityHistory from '../Filter';
import HelpGuideModal from '../../../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../../../features/patientSlice'


const TopBarActivityHistory = ({
    title,
    ApplyFilter,
    filterDateValues,
    setFilterDateValues,
    setFilterValues,
    filterValues,
    initialState,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    data,
    exportActivityHistory,
    isIdexport,
    selectedOrganizationName,
    setSelectedOrganizationName,
    setSubDivisionDataLoading,
    userArr,
    subDivisionDataLoading,
    handleApplyFilter,
    TotalCount
}) => {
   

    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [dateError, setdateError] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const ref = useRef()
    const ref2 = useRef()
    const navigate=useNavigate()
    
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=admin-activity-history');
        } else {
            setQueryParamsadmin('type=admin-activity-history');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })



    const handleCheck=(start_date,end_date)=>{
        if((dayjs(end_date).isBefore(dayjs(start_date)))&&(end_date!==undefined&&start_date!==undefined)){
            return true
        }
        return false
    }

    const handleOpenFilter = () => {
        setdateError(false)
        setIsFilterOpen(!isFilterOpen)

        const params = Object.fromEntries(searchParams);

        setFilterValues((prev) => ({
            ...prev,
            user_name: params.user_name || '',
            field: params.field || '',
            target: params.target || '',
            user_type: params.user_type || '',
            action: params.action || '',
        }));
    }

    function handleSelectDate(id,date,dateString,termkey){
        isFilterOpen&&setIsFilterOpen(false)
        if(id==="filter_end_date"&&filterDateValues?.start_date!==undefined&&handleCheck(filterDateValues?.start_date,dateString)){
            setdateError(true)
            return
        }
        if(id==="filter_start_date"&&filterDateValues?.end_date!==undefined&&handleCheck(dateString,filterDateValues?.end_date)){
            setdateError(true)
            return
        }
        setdateError(false)
        let params = Object.fromEntries(searchParams)
        params.page_number = 1
        params.last_id = null
        params.last_page = null
        if(id==="filter_start_date"){
            setFilterDateValues((prv) => ({
                ...prv,
                start_date: dateString,
            }));
            
            params.start_date =convertDatesToEpochUTC(moment(dateString).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,true)
            setSearchParams({...params})
            
        }
        else{
            setFilterDateValues((prv) => ({
                ...prv,
                end_date: dateString,
            }));
            params.end_date= convertDatesToEpochUTC(moment(dateString).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,false)
            setSearchParams({...params})
        }
        
    }

        
    return (
        <div className="flex justify-between items-center xl:mb-[18px] mb-0">
            <div className='flex items-center'>
                <h1 className="text-xl font-normal text-[#000000] min-w-max xl:self-center self-start xl:mt-0 mt-2">{title}</h1>
                {
                    userType !=='super-admin' &&
                    <button type='button'   onClick={() => setHelpGuideModel(true)} className='ml-2 cursor-pointer min-w-fit xl:z-0 z-[999]'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </button> 
                }

            </div>
          
            {/* <div className="flex items-center w-full justify-end relative flex-wrap">  */}
            <div className='flex items-center flex-wrap relative justify-end'>
                <div className='flex items-center relative'>
                    <span className='absolute top-[38px] left-0'>
                        {dateError &&<p className="text-xs text-red-500 mt-2">Please select the valid date range.</p>}
                    </span>
                    <div className='w-auto mx-2 atr:mb-0 mb-3.5'>
                        <CustomDatePicker 
                            id={"filter_start_date"}
                            classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                            format="MMM DD, YYYY"
                            state={filterDateValues}
                            data-testid={"start_date"}
                            placeholder={"Select start date"}
                            termkey={filterDateValues?.start_date}
                            handleSelect={handleSelectDate}
                            imageClass={true}
                            setdateError={setdateError}
                        />
                    </div>
                    <div className='w-auto atr:mb-0 mb-3.5'>
                        <div className='w-full'>
                            <CustomDatePicker
                                classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                placeholder={"Select end date"}
                                format="MMM DD, YYYY"
                                state={filterDateValues}
                                termkey={filterDateValues?.end_date}
                                handleSelect={handleSelectDate}
                                id={"filter_end_date"}
                                setdateError={setdateError}
                            />
                        </div>
                    </div>
                </div>
                {(ApplyFilter !== undefined && ApplyFilter) &&
                <FilterActivityHistory
                    dateError={dateError}
                    setdateError={setdateError}
                    isFilterOpen={isFilterOpen}
                    setIsFilterOpen={setIsFilterOpen}
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                    initialState={initialState}
                    handleOpenFilter={handleOpenFilter}
                    selectedOrganizationName={selectedOrganizationName}
                    setSelectedOrganizationName={setSelectedOrganizationName}
                    setSubDivisionDataLoading={setSubDivisionDataLoading}
                    subDivisionDataLoading={subDivisionDataLoading}
                    userArr={userArr}
                    handleApplyFilter={handleApplyFilter}
                />
                }
                    
                {data?.data?.length>0&&<div>  <ManageActivityHistoryListExport
                    selectedRows={selectedRows}
                    exportActivityHistory={exportActivityHistory}
                    exportCols={exportCols}
                    setIsFilterOpen={setIsFilterOpen}
                    isColumnSelect={isColumnSelect}
                    setIsColumnSelect={setIsColumnSelect}
                    isIdexport={isIdexport} username={username}
                    TotalCount={TotalCount}
                />
                </div> }
                {/* <Link to={'/manage-activity-history/export_activity_history'} > */}
                <button type='button'
                    onClick={() => 
                        navigate(`/manage-activity-history/export_activity_history`,{state:{"limit":searchParams.get("limit"),"page_number":searchParams.get("page_number"),"last_page": searchParams.get("last_page"),"last_id": searchParams.get("last_id"),"filter": searchParams.get("filter"),"end_date": searchParams.get("end_date"),"start_date": searchParams.get("start_date")}})
                    }
                    id="view_export_history"
                    data-testid={'view_export_history'}
                    className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] min-w-max ml-2.5 
        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] atr:mb-0 mb-3.5`}>
                    View Export History
                </button>
                {/* </Link> */}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                    <HelpGuideModal
                        setHelpGuideModel={setHelpGuideModel}
                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                    />
                }
            </div>
            {/* </div> */}
        </div>
    );
}

export default TopBarActivityHistory;
